import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getBettingMarkets, GetBettingMarketsParams } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "./bettingMarketsQueryKeys";

export const useBettingMarkets = (params: GetBettingMarketsParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return useQuery({
    queryKey: [BettingMarketsQueryKeys.BettingMarkets, fullParams],
    queryFn: ({ signal }) => getBettingMarkets({ params: fullParams, signal }),
  });
};
